/** Unified asset-owner API paths (role 4). Legacy private/business owner routes kept as fallbacks. */
export const ASSET_OWNER_GOOGLE_LOGIN_PATHS = [
  'login/AssetOwner/google',
  'login/BusinessAssetOwner/google',
  'login/PrivateAssetOwner/google',
  'login/assetsowners/google',
  'login/google',
] as const;

export const ASSET_OWNER_GOOGLE_REGISTER_PATHS = [
  'register/AssetOwner/google',
  'register/AssetOwner',
  'register/BusinessAssetOwner/google',
  'register/BusinessAssetOwner',
  'register/PrivateAssetOwner/google',
  'register/PrivateAssetOwner',
] as const;

export function isLegacyAssetOwnerLoginType(loginType: string | null | undefined): boolean {
  return loginType === 'business asset owner' || loginType === 'private asset owner';
}
